define('mixins/TrackingEventMixin',['require','jquery','underscore','lib/Podio.Tracking'],function(require) {

  var $ = require('jquery');
  var _ = require('underscore');

  var tracking = require('lib/Podio.Tracking');

  var types = void 0;

  return {
    setupTracking: function(dataTypes) {
      types = dataTypes;
    },

    handleTrackingEventClick: function(e) {
      if (_.isUndefined(types)) {
        throw new Error('You need to call the `setupTracking` method before any tracking events will succeed. See the readme.md file in the `mixins` directory.');
      }

      var action = e.currentTarget.getAttribute('data-tracking-event-action');

      this.eventTracking(action);
    },

    eventTracking: function(action) {
      if (_.isNull(action)) {
        return new $.Deferred().reject();
      }

      var data = {
        data: {
          action: action
        }
      };

      // Merge in additional data if present
      _.extend(data, types);

      return tracking.eventTracking(data);
    }
  };
});

